import { render, staticRenderFns } from "./AppLogs.vue?vue&type=template&id=a16e115a"
import script from "./AppLogs.vue?vue&type=script&lang=js"
export * from "./AppLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports